import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

export function LogoutPage() {
  const navigate = useNavigate()
  const { signOut } = useAuth()

  useEffect(() => {
    const performSignOut = async () => {
      try {
        await signOut()
        navigate('/login', { replace: true })
      } catch (error) {
        console.error('Error signing out:', error)
        navigate('/login', { replace: true })
      }
    }
    performSignOut()
  }, [signOut, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Signing out...</p>
      </div>
    </div>
  )
}
